import React from 'react';
import { FormattedMessage } from 'react-intl';
import globalMessages from 'translations/messages';

import { Drawer as AntDrawer, Button, Row, Col } from 'antd';
import './drawer.less';
import ErrorBoundary from 'components/ErrorBoundary';
import useFormatMessage from 'hooks/useFormatMessage';
import useGlobalContext from 'hooks/useGlobalContext';

const Drawer = ({
  name,
  children,
  footer,
  onOk,
  confirmLoading,
  okLabel,
  isTouched,
  onCancel,
  cancelLabel,
  onClose,
  onRemove,
  removeLabel,
  width = 600,
  ...rest
}) => {
  const $t = useFormatMessage();
  const { modal } = useGlobalContext();

  const onRemoveHandler = onRemove && (async () => {
    modal.confirm({
      title: $t(globalMessages.confirmDelete, { title: removeLabel }),
      okText: $t(globalMessages.delete),
      okType: 'danger',
      confirmLoading: true,
      onOk: onRemove,
    });
  });

  if (footer == null && (onOk || onCancel || onRemove)) {
    footer = (
      <Row justify="space-between">
        <Col>
          {onOk && (
          <Button type="primary" loading={confirmLoading} onClick={onOk} className={name && `${name}-save`} disabled={isTouched === false}>
            {okLabel || <FormattedMessage {...globalMessages.save} />}
          </Button>
          )}
          {onCancel && (
          <Button style={{ marginLeft: 8 }} onClick={onCancel} className={name && `${name}-cancel`}>
            {cancelLabel || <FormattedMessage {...globalMessages.cancel} />}
          </Button>
          )}
        </Col>
        {onRemove && (
        <Col>
          <Button danger onClick={onRemoveHandler} className={name && `${name}-remove`}>
            <FormattedMessage {...globalMessages.delete} />
          </Button>
        </Col>
        )}
      </Row>
    );
  }

  return (
    <AntDrawer width={width} footer={footer} onClose={onClose || onCancel} {...rest}>
      <ErrorBoundary>
        {children}
      </ErrorBoundary>
    </AntDrawer>
  );
};

export default Drawer;
